module.exports = __webpack_public_path__ + "img/og-image_handbook_pocket_en.bf25bb8.jpg";